import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ComponentButton = ({ id, isLoading = false, onClick, children, isSubmit = false, isAlert = false, isDisabled = false, classes = '', 'data-gtm': dataGtm = false }) => {
    const className = classNames({
        button: true,
        'button--icon': true,
        [classes]: true,
        redalert: isAlert,
        'button--loading': isLoading
    });
    const type = isSubmit ? 'submit' : 'button';
    const iconStyle = { opacity: isLoading ? 1 : 0 };
    const textStyle = { opacity: isLoading ? 0 : 1 };
    return (_jsxs("button", Object.assign({ id: id, type: type, className: className, onClick: onClick, disabled: isDisabled }, (dataGtm ? { 'data-gtm': dataGtm } : {}), { children: [_jsx("span", Object.assign({ className: 'button--spinner' }, { children: _jsx("i", { className: 'fas fa-spinner-third fa-spin', style: iconStyle }) })), _jsx("span", Object.assign({ style: textStyle }, { children: children }))] })));
};
ComponentButton.propTypes = {
    id: PropTypes.string,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    isSubmit: PropTypes.bool,
    isAlert: PropTypes.bool,
    isDisabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    classes: PropTypes.string,
    'data-gtm': PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
export default ComponentButton;
